import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/login.vue'),
      meta: { title: '登录 - 调研问卷数据管理系统' }
    },
    {
      path: '/survey_list',
      name: 'SurveyList',
      component: () => import('@/components/surveyList.vue'),
      meta: { title: '问卷管理' }
    },
    {
      path: '/claw_survey_create',
      name: 'ClawSurveyCreate',
      component: () => import('@/components/clawSurveyCreate.vue'),
      meta: { title: '一键制表' }
    },
    {
      path: '/manual_survey_create',
      name: 'ManualSurveyCreate',
      component: () => import('@/components/manualSurveyCreate.vue'),
      meta: { title: '手工制表' }
    },
    {
      path: '/question_manage',
      name: 'QuestionManage',
      component: () => import('@/components/questionManager.vue'),
      meta: { title: '管理题目' }
    },
    {
      path: '/material_generate',
      name: 'MaterialGenerate',
      component: () => import('@/components/materialGenerate.vue'),
      meta: { title: '根据材料生成题目' }
    },
    {
      path: '/answer_setting',
      name: 'AnswerSetting',
      component: () => import('@/components/answerSetting.vue'),
      meta: { title: '设置答案' }
    },
    {
      path: '/auto_grading',
      name: 'AutoGrading',
      component: () => import('@/components/autoGrading.vue'),
      meta: { title: '自动阅卷' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js